import {
    ChangeDetectorRef,
    Component,
    forwardRef,
    OnInit,
    ChangeDetectionStrategy,
    inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryObserverResult } from '@tanstack/query-core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LocationDataService } from '../../services/location-data.service';
import { VirtualizationSettings } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'app-origin-filter',
    templateUrl: './origin-filter.component.html',
    styleUrls: ['./origin-filter.component.scss'],
    imports: [AsyncPipe, LabelModule, DropDownsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OriginFilterComponent),
            multi: true,
        },
    ],
})
export class OriginFilterComponent implements ControlValueAccessor, OnInit {
    private locationDataService = inject(LocationDataService);
    private cdr = inject(ChangeDetectorRef);

    public originQueryResults$?: Observable<
        QueryObserverResult<string[], Error>
    >;

    public isDisabled: boolean = false;
    public value: string[] = [];
    public virtual: VirtualizationSettings = { itemHeight: 28 };

    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(value: string[] | null): void {
        this.value = value ?? [];
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    handleValueChange(value: string[]): void {
        this.value = value;
        this.onChange(value);
    }

    handleBlur(): void {
        this.onTouched();
    }

    ngOnInit(): void {
        this.originQueryResults$ = this.locationDataService.getSubRegions(
            'origin',
            'trip',
        ).result$;
    }
}
